<template>
    <div class="home">
        <div v-show="currentPanel == 'start'">
            <StartPanelFusion360 :searchType="searchType" :manufacturerItems="manufacturerItems"></StartPanelFusion360>
        </div>
        <div v-show="currentPanel == 'search'">
            <SearchPanel :searchType="searchType" :manufacturerItems="manufacturerItems"></SearchPanel>
        </div>
        <div v-show="currentPanel == 'reference'">
            <ReferenceSearchPanel></ReferenceSearchPanel>
        </div>
        <div v-show="currentPanel == 'placeholder'">
            <PlaceholderPanel></PlaceholderPanel>
        </div>
        <div v-show="currentPanel == 'part'">
            <PartPanel></PartPanel>
        </div>
        <div v-show="currentPanel == 'error'">
            <div class="tab-content ul-red-panel ul-wide-border-panel mb-3">
                <div class="download-panel hide-flex flex-column align-items-center justify-content-center mt-2" v-show="currentPanel == 'download'">
                    <img class="export-image" src="@/assets/images/placeholders/UL-Loading-Done.gif" />
                    <h2 class="mb-3">System Error</h2>
                    <div class="mb-3">
                        {{errorContent}}
                    </div>
                    <div class="d-flex flex-column align-items-center justify-content-center mt-2 mb-2">
                        <a class="small back-link" v-on:click.prevent="returnLink">Back to Previous</a>
                    </div>
                </div>
            </div>
        </div>
        <hr />
        <footer class="text-center">
            <p>
                &copy; Copyright Ultra Librarian {{ new Date().getFullYear() }}
            </p>
        </footer>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex'
    import StartPanelFusion360 from '@/components/start/fusion360start.vue'
    import SearchPanel from '@/components/search/search-panel.vue'
    import PartPanel from '@/components/part/part-panel.vue'
    import PlaceholderPanel from '@/components/part/placeholder-panel.vue'
    import partApiClient from '@/services/apiServices/partApiClient.js'
    import ReferenceSearchPanel from '@/components/reference/reference-search-panel.vue'

    export default {
        name: 'Home',
        components: {
            StartPanelFusion360,
            SearchPanel,
            PartPanel,
            PlaceholderPanel,
            ReferenceSearchPanel
        },
        computed: {
            ...mapGetters('oidcStore', [
                'oidcUser'
            ]),
            ...mapState({
                user: state => state.user,
                currentPanel: state => state.navigation.currentPanel,
                searchType: state => state.search.type,
            })
        },
        data() {
            return {
                manufacturerItems: [],
                errorContent: ""
                //perhaps map this from vuex, so routing to home wihle it's active works? Looks like a lot of exception cathcing needs work.
            }
        },
        methods: {
            setup: async function () {
                await this.$router.isReady();

                partApiClient.GetManufacturerListing().then(response => {
                    if (response.data.success) {
                        this.manufacturerItems = response.data.manufacturerItems
                    } else {
                        this.$store.commit('SET_GLOBAL_ERROR', 'Content Api Unavailable');
                    }
                }).catch(() => {
                    this.$store.commit('SET_GLOBAL_ERROR', 'Content Api Connection Failed');
                });
            }
        },
        created() {
        },
        mounted() {
            this.setup();
        }
    };
</script>

<style>
    :root {
        --ul-red: #c51730;
        --ul-dark-gray: #5A5A5A;
        --ul-dark-gray-bg: #737373;
        --ul-light-gray: #d0d0d0;
        --ul-light-gray-bg: #d0d0d0;
        --ul-very-light-gray: #f6f6f6;
    }

    * {
        border-radius: 0 !important;
    }

    body {
        padding-top: 0px;
        padding-bottom: 0;
        max-width: 450px;
        margin: auto !important;
        min-height: 100%;
        height: 100%;
        font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
        background-color: #fff;
    }

    .home{
        padding-top: 5px;
    }

    .ul-dark-gray-panel {
        border: 1px solid var(--ul-dark-gray);
    }

    .ul-wide-dark-gray-panel {
        border-left: 10px solid var(--ul-dark-gray) !important;
    }

    .ul-light-gray-panel {
        border: 1px solid var(--ul-light-gray);
    }

    .ul-wide-light-gray-panel {
        border-left: 10px solid var(--ul-light-gray) !important;
    }

    .ul-light-gray-panel-bottom {
        border-bottom: 1px solid var(--ul-light-gray);
    }

    .ul-very-light-background {
        background-color: var(--ul-very-light-gray);
    }

    .ul-light-background {
        background-color: var(--ul-light-gray-bg);
    }

    .ul-dark-background {
        background-color: var(--ul-dark-gray-bg);
    }

    .ul-red-panel {
        border: 1px solid var(--ul-red);
    }

    .ul-wide-border-panel {
        border-left: 10px solid var(--ul-red) !important;
    }

    .required {
        color: var(--ul-red);
    }

    .preview-title {
        font-size: 16px;
        font-weight: bold;
        color: var(--ul-dark-gray);
        padding: 5px 0px 5px 0px;
    }

    .back-link {
        color: var(--ul-dark-gray);
    }

    .btn-light {
        color: var(--ul-red);
        background-color: #fff;
        border: 1px solid var(--ul-red);
    }

    .btn-dark {
        color: #fff !important;
        background-color: var(--ul-red);
        border: 1px solid var(--ul-red);
    }

    .btn-primary {
        color: #fff !important;
        background-color: var(--ul-dark-gray-bg);
        border-color: var(--ul-dark-gray-bg);
        color: var(--ul-dark-gray);
    }

    .btn-primary:hover {
        color: #fff !important;
        background-color: var(--ul-light-gray-bg);
        border-color: var(--ul-light-gray-bg);
        color: var(--ul-light-gray);
    }

    .btn-default {
        color: #333;
        background-color: #fff;
        border-color: #ccc;
    }

    .btn.disabled, .btn:disabled, .btn[disabled], fieldset[disabled] .btn {
        cursor: not-allowed;
    }

    .btn-dark.disabled, .btn-dark:disabled, .btn-dark[disabled] {
        color: white;
        background-color: var(--ul-red);
        border-color: var(--ul-red);
        opacity: .65;
    }

    .export-listing, .consent-listing {
        column-count: 1;
        list-style-type: none;
        padding: 0px;
    }

    .export-listing li, .consent-listing li {
        padding: 0px;
    }

    .consent-listing {
        margin: 0em 2em;
    }

    .model-availability-symbol-active {
        background-image: url('../assets/images/symbols/SymbolYes.svg');
    }

    .model-availability-footprint-active {
        background-image: url('../assets/images/symbols/FootprintYes.svg');
    }

    .model-availability-threed-active {
        background-image: url('../assets/images/symbols/3DYes.svg');
    }

    .model-availability-symbol-inactive {
        background-image: url('../assets/images/symbols/SymbolNo.svg');
    }

    .model-availability-footprint-inactive {
        background-image: url('../assets/images/symbols/FootprintNo.svg');
    }

    .model-availability-threed-inactive {
        background-image: url('../assets/images/symbols/3DNo.svg');
    }

    .search-result-item {
        border: 1px solid #dbdbdb;
    }

    .search-result-item-mfr-heading {
        flex: 0 0 30%;
    }

    .search-result-item-border {
        border-left: 1px solid #dbdbdb;
    }

    .search-result-item-description {
        max-width: 540px;
        height: 40px;
        overflow: hidden;
        -ms-word-break: break-all;
        word-break: break-all;
        word-break: break-word;
        -webkit-hyphens: auto;
        -moz-hyphens: auto;
        -ms-hyphens: auto;
        hyphens: auto;
        width: 100% !important;
    }

    .btn-search {
        width: 100px;
    }

    .search-input {
        float: left;
        width: calc(100% - 100px);
    }

    .search-form {
        padding-bottom: 1em;
    }

    .part-image {
        max-height: 50px;
        max-width: 75px;
    }

    .part-image-credit {
        font-size: .5em;
    }

    .svg-inline--fa {
        position: relative;
    }

    .download-panel {
        text-align: center;
        padding-bottom: 16px;
    }

    .export-panel {
        text-align: center;
        padding: 0px 56px 16px 56px;
    }

    .export-listing {
        margin-bottom: .25em;
    }

    .ul-tooltip, .ul-html-tooltip {
        cursor: pointer;
        padding-left: 5px;
    }

    .tooltip {
        width: auto;
        max-width: 425px;
    }

    .tooltip-inner {
        width: 100%;
        max-width: none;
    }

    .tooltip > .tooltip-inner {
        background-color: black;
        border-top: 2px solid var(--ul-red);
        border-bottom: 2px solid var(--ul-red);
    }

    .bs-tooltip-auto[x-placement^=top] .arrow::before, .bs-tooltip-top .arrow::before {
        border-top-color: var(--ul-red);
    }

    .bs-tooltip-auto[x-placement^=right] .arrow::before, .bs-tooltip-right .arrow::before {
        border-right-color: var(--ul-red);
    }

    .bs-tooltip-auto[x-placement^=bottom] .arrow::before, .bs-tooltip-bottom .arrow::before {
        border-bottom-color: var(--ul-red);
    }

    .bs-tooltip-auto[x-placement^=left] .arrow::before, .bs-tooltip-left .arrow::before {
        border-left-color: var(--ul-red);
    }

    @media (max-width: 434.9px ) {
        i.fa {
            font-size: 200%;
        }
    }

    @media (max-width: 1299.9px) {

        body {
            font-size: 80%;
            min-width: 434.9px;
        }

        .ms-5-r {
            margin-left: 1.5rem;
            margin-right: 1.5rem;
        }

        .option-content-div {
            width: 100%;
        }

        .search-result-item-description {
            height: 32px;
        }

        .model-availability-listing div {
            height: 18px;
            width: 30px;
            margin: 2px 3px 1px 3px;
            display: inline-block;
        }

        .search-result-content {
            column-count: 1;
        }

        div.react-hidden {
            display: none !important;
        }
    }

    @media (min-width: 1300px ) {
        body {
            max-width: 1300px;
            padding: 0px;
        }

        .ms-5-r {
            margin-left: 3rem;
            margin-right: 3rem;
        }

        .pl-5-max {
            padding-left: 3rem !important;
        }

        .ps-2-max {
            padding-left: 0.5rem !important;
            padding-right: 0.5rem !important;
        }

        .export-listing {
            column-count: 2;
        }

        .export-listing li {
            overflow: hidden; /* fix for Firefox */
            break-inside: avoid-column;
            -webkit-column-break-inside: avoid;
        }

        .model-availability-listing div {
            height: 25px;
            width: 38px;
            margin: 4px 6px 2px 6px;
            display: inline-block;
        }

        .search-result-content {
            column-count: 2;
        }
    }
</style>

